import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LandingPage } from "./components/LandingPage";
import { AboutPage } from "./components/AboutPage";
import { ServicesPage } from "./components/ServicesPage";
import { ExpertisePage } from "./components/ExpertisePage";
import { WhyPage } from "./components/WhyPage";
import { ContactPage } from "./components/ContactPage";
import { ThanksPage } from "./components/ThanksPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/expertise" element={<ExpertisePage />} />
          <Route path="/why" element={<WhyPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/thanks" element={<ThanksPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;